import React from "react";
import { Helmet } from "react-helmet-async";

import Navbar from "./Navbar";
import Footer from "./Footer";

interface LayoutProps {
  children: React.ReactNode;
  meta?: {
    title?: string;
    description?: string;
    keywords?: string;
  };
}

const Layout: React.FC<LayoutProps> = ({ children, meta }) => {
  const {
    title = "Invyntra Dashboard",
    description = "Inventory Management System",
    keywords = "inventory, management, products, purchases, sales, suppliers",
  } = meta || {};

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />

        {/* Optional Open Graph tags for richer sharing */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Invyntra" />
      </Helmet>

      <Navbar />
      <main className="min-h-[80vh]">{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
